// extracted by mini-css-extract-plugin
export default {"HomePage":"HomePage_HomePage__VnKTm","innerImage":"HomePage_innerImage__U67yY"};